{
    "type": {
        "percentage": "Porcentaje",
        "amount": "Monto fijo",
        "basePrice": "Precio base"
    },
    "applicableTo": {
        "BUY": "Compra",
        "GIFT": "Regalo",
        "RENEW": "Renovación"
    }
}
